// extracted by mini-css-extract-plugin
export var legendIndicator = "_ep-1";
export var legendRight = "_ep-0";